import { render, staticRenderFns } from "./OtherInBillList.vue?vue&type=template&id=50b0cbc6&scoped=true&"
import script from "./OtherInBillList.vue?vue&type=script&lang=js&"
export * from "./OtherInBillList.vue?vue&type=script&lang=js&"
import style0 from "./OtherInBillList.vue?vue&type=style&index=0&id=50b0cbc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0cbc6",
  null
  
)

export default component.exports